import { render, staticRenderFns } from "./RosterChecklistAdvice.vue?vue&type=template&id=c6f54712&scoped=true&"
import script from "./RosterChecklistAdvice.vue?vue&type=script&lang=js&"
export * from "./RosterChecklistAdvice.vue?vue&type=script&lang=js&"
import style0 from "./RosterChecklistAdvice.vue?vue&type=style&index=0&id=c6f54712&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f54712",
  null
  
)

export default component.exports